import { convertRange } from '../../../../helperFunctions';

import { dataCodeFields } from '../../../../config/dataCodes';

export const generateSalesGaugeData = (type, data) => {
  switch (type) {
    case 'brand':
      let generatedData = {
        brandPerformance: [],
        socialValueDimensions: [],
      };
      //brandPerformance
      generatedData.brandPerformance.push({
        body1: {
          headingText: 'Social Values Match',
          bodyText: 'Match between Audience Persona Social Values and Consumer Social Values',
        },
        data: [
          {
            category: 'VALUES MATCH',
            value: Number((data.Values_Match * 100).toFixed(0)),
            full: 100,
          },
        ],
      });
      generatedData.brandPerformance.push({
        body1: {
          headingText: 'Total Match',
          bodyText: 'An index based on the combination of Social Values Match and Product Benefits Match',
        },
        data: [
          {
            category: 'TOTAL MATCH',
            value: Number((data.Total_Match * 100).toFixed(0)),
            full: 100,
          },
        ],
      });
      generatedData.brandPerformance.push({
        body1: {
          headingText: 'Product Benefits Match',
          bodyText: 'Match between Audience Persona Product Benefits and Consumer Preferred Product Benefits Values',
        },
        data: [
          {
            category: 'BENEFITS MATCH',
            value: Number((data.Product_Match * 100).toFixed(0)),
            full: 100,
          },
        ],
      });

      //socialValueDimensions
      generatedData.socialValueDimensions.push({
        body1: {
          headingText: 'Internal vs External Focus Match',
          bodyText: 'Measures if consumers and audience persona focus more on personal benefits or society around them.',
        },
        data: [
          {
            category: 'FOCUS MATCH',
            value: Number((data.IE_Focus_Match * 100).toFixed(0)),
            full: 100,
          },
        ],
      });
      generatedData.socialValueDimensions.push({
        body1: {
          headingText: 'Ideology Match',
          bodyText:
            'Positions consumers and audience persona on a traditional liberal/conservative scale, considering economic, social, and safety dimensions of ideology.',
        },
        data: [
          {
            category: 'IDEOLOGY MATCH',
            value: Number((data.Ideology_Match * 100).toFixed(0)),
            full: 100,
          },
        ],
      });
      generatedData.socialValueDimensions.push({
        body1: {
          headingText: 'Social Issues Match',
          bodyText:
            'Measures how much importance consumers and audience persona place on the most 11 social issues that are commonly used in political research, including gender inequality, state of the economy, climate change, etc.',
        },
        data: [
          {
            category: 'SOCIAL ISSUES',
            value: Number((data.Issues_Match * 100).toFixed(0)),
            full: 100,
          },
        ],
      });
      generatedData.socialValueDimensions.push({
        body1: {
          headingText: 'Causes Support Match',
          bodyText:
            'Explores the alignment between consumer support and audience persona advocacy for 18 social and political issues, including topics such as abortion rights, free healthcare, gun restrictions, police reform, same-sex marriage, and other key issues shaping public discourse and corporate responsibility.',
        },
        data: [
          {
            category: 'CAUSES SUPPORT',
            value: Number((data.CausesSupport_Match * 100).toFixed(0)),
            full: 100,
          },
        ],
      });

      return generatedData;
    default:
      return null;
  }
};

const productTextConfig = [
  {
    leftText: 'Price',
    rightText: 'Quality',
  },
  {
    leftText: 'Design',
    rightText: 'Functionality',
  },
  {
    leftText: 'Polite Service',
    rightText: 'Fast Service',
  },
  {
    leftText: 'Professionalism',
    rightText: 'Easy Going',
  },
  {
    leftText: 'Durability',
    rightText: 'Affordability',
  },
  {
    leftText: 'Uniqueness',
    rightText: 'Compatibility',
  },
  {
    leftText: 'Privacy',
    rightText: 'Personalization',
  },
  {
    leftText: 'Convenience',
    rightText: 'Exclusivity',
  },
  {
    leftText: 'Core Product',
    rightText: 'Customer Support',
  },
  {
    leftText: 'Experience',
    rightText: 'Ownership',
  },
];

const productBenefitsRangeToDisplayData_Text_Dynamic = (index, brandValue, consumerValue) => {
  const body = getProductBenefitsRangeText(index, brandValue, consumerValue);
  return { ...productTextConfig[index], body };
};

const getProductBenefitsRangeText = (index, brandValue, consumerValue) => {
  const leftText = productTextConfig[index].leftText.toLocaleLowerCase();
  const rightText = productTextConfig[index].rightText.toLocaleLowerCase();

  let consumerTextPart = '';
  let brandTextPart = '';
  if (consumerValue < -0.1) {
    consumerTextPart = `Consumers value ${leftText} over ${rightText}. `;
    if (brandValue !== null) {
      if (brandValue - consumerValue < -0.1) {
        brandTextPart = `To improve Product Benefit Match, audience persona should place less value on ${leftText}.`;
      } else if (brandValue - consumerValue > 0.1) {
        brandTextPart = `To improve Product Benefit Match, audience persona should place more value on ${leftText}.`;
      } else {
        brandTextPart = `This audience persona values ${leftText} similarly to consumers.`;
      }
    }
  } else if (consumerValue > 0.1) {
    consumerTextPart = `Consumers value ${rightText} over ${leftText}. `;
    if (brandValue !== null) {
      if (brandValue - consumerValue < -0.1) {
        brandTextPart = `To improve Product Benefit Match, audience persona should place more value on ${rightText}.`;
      } else if (brandValue - consumerValue > 0.1) {
        brandTextPart = `To improve Product Benefit Match, audience persona should place less value on ${rightText}.`;
      } else {
        brandTextPart = `This audience persona values ${rightText} similarly to consumers.`;
      }
    }
  } else {
    consumerTextPart = `Consumers value ${rightText} and ${leftText} equally. `;
    if (brandValue !== null) {
      if (brandValue - consumerValue < -0.1) {
        brandTextPart = `To improve Product Benefit Match, audience persona should balance between ${leftText} and ${rightText}.`;
      } else if (brandValue - consumerValue > 0.1) {
        brandTextPart = `To improve Product Benefit Match, audience persona should balance between ${leftText} and ${rightText}.`;
      } else {
        brandTextPart = `This audience persona values ${leftText} and ${rightText} similarly to consumers.`;
      }
    }
  }

  return consumerTextPart + brandTextPart;
};

export const generateRangeChartData = (persona, batchData, type, personaType) => {
  // We filter out PersonalIssuesSupport but we still use PersonalIssuesSupport_n
  return Object.keys(batchData)
    .filter(e => e !== 'PersonalIssuesSupport')
    .map((el, index) => {
      let personaText = '';

      if (personaType == 'brand') {
        personaText = el.replace('Personal', 'Brand_');
        if (personaText === 'Brand_SocialInovat') personaText = 'Brand_SocialInovation';
      } else if (personaType == 'buyer') {
        personaText = el.replace('Personal', 'Buyer_');
        if (personaText === 'Buyer_SocialInovat') personaText = 'Buyer_SocialInovation';
      }

      let personaValue = Math.round(Number(persona[personaText]) * 100);
      let batchValue = Math.round(Number(batchData[el]) * 100);
      let displayData =
        type === 'product'
          ? productBenefitsRangeToDisplayData_Text_Dynamic(
              index,
              convertRange(Number(persona[personaText]), [0, 1], [-1, 1]),
              convertRange(Number(batchData[el]), [0, 1], [-1, 1]),
            )
          : type === 'support'
          ? issuesSupportRangeToDisplayData(index)
          : socialRangeToDisplayData(index);
      return {
        ...displayData,
        personaValue: convertRange(personaValue, [0, 100], [-100, 100]),
        batchValue: convertRange(batchValue, [0, 100], [-100, 100]),
      };
    });
};

const issuesSupportTextConfig = [
  'Abortion rights',
  'Sexual Education Funding',
  'Free healthcare - national health service',
  'Gun restrictions',
  'Police reform',
  'Same sex marriage',
  'LGBTQ+ adoption rights',
  'Gender transition',
  'Transgender athletes',
  'Gender identity education',
  'Gender workplace diversity',
  'Open immigration',
  'Affirmative action',
  'Increased racial and ethnic diversity',
  'Wealth tax for the rich',
  'Increased corporate taxation',
  'Socialism',
  'Government regulation',
];

export const issuesSupportRangeToDisplayData = index => {
  return { leftText: 'Oppose', rightText: 'Support', heading: issuesSupportTextConfig[index] };
};

export const generateRangeChartData_ConsumerDashboard = (batchData, type) => {
  // We filter out PersonalIssuesSupport but we still use PersonalIssuesSupport_n
  return Object.keys(batchData)
    .filter(e => e !== 'PersonalIssuesSupport')
    .map((el, index) => {
      let batchValue = Math.round(Number(batchData[el].total) * 100);
      let displayData =
        type === 'product'
          ? productBenefitsRangeToDisplayData_Text_Dynamic(index, null, convertRange(Number(batchData[el]), [0, 1], [-1, 1]))
          : type === 'support'
          ? issuesSupportRangeToDisplayData(index)
          : socialRangeToDisplayData(index);

      return {
        ...displayData,
        batchValue: convertRange(batchValue, [0, 100], [-100, 100]),
      };
    });
};

export const generateConsumerGroupsData = (type, batchData) => {
  return Object.keys(batchData).map((el, index) => {
    let highValue = Math.round(Number(batchData[el].low) * 100 * 10) / 10;
    let mediumValue = Math.round(Number(batchData[el].medium) * 100 * 10) / 10;
    let lowValue = Math.round(Number(batchData[el].high) * 100 * 10) / 10;

    let displayData = type === 'product' ? productBenefitsRangeToDisplayData(index) : issuesSupportRangeToDisplayData(index);

    return {
      ...displayData,
      highValue,
      mediumValue,
      lowValue,
    };
  });
};

export const generateConsumerSocialValuesData = batchData => {
  return Object.keys(batchData).map((el, index) => {
    let highValue = Math.round(Number(batchData[el].low) * 100 * 10) / 10;
    let mediumValue = Math.round(Number(batchData[el].medium) * 100 * 10) / 10;
    let lowValue = Math.round(Number(batchData[el].high) * 100 * 10) / 10;

    let displayData = socialRangeToDisplayData(index);

    return {
      ...displayData,
      highValue,
      mediumValue,
      lowValue,
    };
  });
};

export const productBenefitsRangeToDisplayData = index => {
  const configObject = [
    {
      leftText: 'Price',
      rightText: 'Quality',
      body: 'Consumers value price over quality. To improve Product Benefit Match, brand should place less value on price.',
    },
    {
      leftText: 'Design',
      rightText: 'Functionality',
      body:
        'Consumers value design over functionality. To improve Product Benefit Match, brand should place more value on design.',
    },
    {
      leftText: 'Polite Service',
      rightText: 'Fast Service',
      body:
        'Consumers value polite service over fast service. To improve Product Benefit Match, brand should place more value on polite service.',
    },
    {
      leftText: 'Professionalism',
      rightText: 'Easy Going',
      body:
        'Consumers value professionalism over easy going attitude. Your brand values professionalism and easy going attitude similarly to consumers.',
    },
    {
      leftText: 'Durability',
      rightText: 'Affordability',
      body:
        'Consumers value affordability over durability. To improve Product Benefit Match, brand should place less value on affordability.',
    },
    {
      leftText: 'Uniqueness',
      rightText: 'Compatibility',
      body:
        'Consumers value compatibility over uniqueness. To improve Product Benefit Match, brand should place more value on compatibility.',
    },
    {
      leftText: 'Privacy',
      rightText: 'Personalization',
      body:
        'Consumers value personalization over privacy. To improve Product Benefit Match, brand should place more value on personalization.',
    },
    {
      leftText: 'Convenience',
      rightText: 'Exclusivity',
      body:
        'Consumers value exclusivity and convenience similarly. Your brand values convenience and exclusivity similarly to consumers.',
    },
    {
      leftText: 'Core Product',
      rightText: 'Customer Support',
      body:
        'Consumers value customer support and core product similarly. To improve Product Benefit Match, brand should balance between core product and customer support.',
    },
    {
      leftText: 'Experience',
      rightText: 'Ownership',
      body:
        'Consumers value ownership and experience similarly. To improve Product Benefit Match, brand should balance between ownership and experience.',
    },
  ];
  return configObject[index];
};

const socialRangeToDisplayData = index => {
  const configObject = [
    {
      leftText: 'Local',
      rightText: 'Global',
      heading: 'Perspective',
      body:
        'Comparisons of perspectives consumers and audience persona take. Local perspective is more about local and national approach, while global is more international and cosmopolitan. ',
    },
    {
      leftText: 'Internal',
      rightText: 'External',
      heading: 'Focus',
      body:
        "Comparison of consumers' and audience persona focus  on personal benefits (internal) or society around them (external).",
    },
    {
      leftText: 'Liberal',
      rightText: 'Conservative',
      heading: 'Ideology',
      body: 'Comparison of liberal vs conservative ideological split  between  consumers and audience persona.',
    },
    {
      leftText: 'Low',
      rightText: 'High',
      heading: 'Social Innovativeness',
      body: 'Comparison of social innovativeness between consumers and audience persona.',
    },
  ];
  return configObject[index];
};

export const cleanPersonaAndBatchData = (persona, batch) => {
  let batchFields = [];
  let batchKeys = Object.keys(batch);

  let personaFields = [];
  let personaKeys = Object.keys(persona);
  Object.keys(dataCodeFields).forEach(dataCodeKey => {
    let foundPersonaKey = personaKeys.find(personaKey => dataCodeKey === personaKey);
    let foundBatchKey = batchKeys.find(batchKey => dataCodeKey === batchKey);
    if (dataCodeFields[foundPersonaKey]) {
      let foundElement = dataCodeFields[foundPersonaKey].find(
        dataCodeElement => dataCodeElement.value === persona[foundPersonaKey],
      );
      personaFields.push(foundElement.text);
    } else {
      if (dataCodeFields[foundPersonaKey] === null) {
        personaFields.push(persona[foundPersonaKey]);
      } else {
        personaFields.push('-');
      }
    }

    if (dataCodeFields[foundBatchKey]) {
      let foundElement = dataCodeFields[foundBatchKey].find(
        dataCodeElement => dataCodeElement.value === batch[foundBatchKey],
      );
      batchFields.push(foundElement.text);
    } else {
      if (dataCodeFields[foundBatchKey] === null) {
        batchFields.push(batch[foundBatchKey] || '-');
      } else {
        batchFields.push('-');
      }
    }
  });

  return [personaFields, batchFields];
};

export const makeDataStructureForDataTabel = (criteria, persona, batch) => {
  const cleanData = [];
  for (let index = 0; index < criteria.length; index++) {
    cleanData.push({
      criteria: criteria[index],
      personaInfo: persona[index],
      batchInfo: batch[index],
    });
  }
  return cleanData;
};

export const generateRadarChartData = (persona, type, data, subjects, labels) => {
  switch (persona) {
    case 'brand':
      if (type === 'single') {
        return subjects.map((subject, index) => ({
          subject: subject,
          A: Number((data[index] * 100).toFixed(0)),
          fullMark: 100,
        }));
      } else {
        return subjects.map((subject, index) => {
          const count = index + 1;
          const AValue = Number((data[1]['Brand_Issues_' + count] * 100).toFixed(0));
          const BValue = Number((data[0]['PersonalIssues_' + count] * 100).toFixed(0));
          return {
            subject,
            [labels[0]]: AValue ? AValue : 1,
            [labels[1]]: BValue ? BValue : 1,
            fullMark: 100,
          };
        });
      }
    case 'buyer':
      if (type === 'single') {
        return subjects.map((subject, index) => ({
          subject: subject,
          A: Number((data[index] * 100).toFixed(0)),
          fullMark: 100,
        }));
      } else {
        return subjects.map((subject, index) => {
          const count = index + 1;
          const AValue = Number((data[1]['Buyer_Issues_' + count] * 100).toFixed(0));
          const BValue = Number((data[0]['PersonalIssues_' + count] * 100).toFixed(0));
          return {
            subject,
            [labels[0]]: AValue ? AValue : 1,
            [labels[1]]: BValue ? BValue : 1,
            fullMark: 100,
          };
        });
      }
    case 'consumerDashboard':
      if (type === 'single') {
        return subjects.map((subject, index) => {
          const count = index + 1;

          return {
            subject: subject,
            A: Number((data[0]['PersonalIssues_' + count] * 100).toFixed(0)),
            fullMark: 100,
          };
        });
      }
    default:
      return null;
  }
};

// Finish this
export const generateRadarChartData_ConsumerDashboard = (data, subjects, labels) => {
  if (type === 'single') {
    return subjects.map((subject, index) => ({
      subject: subject,
      A: Number((data[index] * 100).toFixed(0)),
      fullMark: 100,
    }));
  } else {
    return subjects.map((subject, index) => {
      const count = index + 1;
      const AValue = Number((data[1]['Brand_Issues_' + count] * 100).toFixed(0));
      const BValue = Number((data[0]['PersonalIssues_' + count] * 100).toFixed(0));
      return {
        subject,
        [labels[0]]: AValue ? AValue : 1,
        [labels[1]]: BValue ? BValue : 1,
        fullMark: 100,
      };
    });
  }
};

export const buyerDashboardRadarChartSubjects = {
  brandMatch: [
    'Internal vs External Focus Match',
    'Social Issues,Match',
    'Causes Support,Match',
    'Ideology Match',
    'Social Innovation,Match',
    'Product,Benefits Match',
  ],
  socialIssues: [
    'State of the Economy',
    'Free Healthcare',
    'Violent Crime',
    'World Peace',
    'Gun Laws',
    'Race and Ethnic Inequality',
    'Gender Inequality',
    'Immigration',
    'Economic Inequality',
    'Climate Change',
    'Corporate Corruption',
  ],
};

export const socialValueDimensionsExplanations = [
  {
    heading: 'Internal vs External Focus Match',
    body: "Measures if consumers and audience persona focus more on personal benefits or society around them.",
  },
  {
    heading: 'Social Issues Match',
    body:
      'Measures how much importance consumers and audience persona place on the most 11 social issues that are commonly used in political research, including gender inequality, state of the economy, climate change, etc.',
  },
  {
    heading: 'Causes Support Match',
    body:
      'Explores the alignment between consumer support and audience persona advocacy for 18 social and political issues, including topics such as abortion rights, free healthcare, gun restrictions, police reform, same-sex marriage, and other key issues shaping public discourse and corporate responsibility.',
  },
  {
    heading: 'Ideology Match',
    body:
      'Positions consumers and audience persona take on a traditional liberal/conservative scale, considering the economic, social, and safety dimensions of ideology.',
  },
  {
    heading: 'Social Innovation Match',
    body: 'Measures how much match exists between the level of social invasiveness of consumers and audience persona.',
  },
  {
    heading: 'Product Benefits Match',
    body: 'Match between Audience Persona Product Benefits and Consumers’ Preferred Product Benefits Values.',
  },
];

export const getProductBenefitsSubHeading = () => {
  return `Positions consumers and audience persona take on a traditional liberal/conservative scale, considering the economic, social, and safety dimensions of ideology.`;
};

export const getTop3SocialCauses = causes => {
  // Sort the list based on "2022 Consumers" value in descending order
  const sortedList = causes.sort((a, b) => b['SELECTED SAMPLE'] - a['SELECTED SAMPLE']);

  // Return the top 3 objects
  return sortedList.slice(0, 3);
};

export const getIndustryAverage = (field, data) => {
  let values = data.map(industry => industry.match[field]);
  let sum = values.reduce((a, b) => a + b, 0);
  return sum / values.length;
};

export const getValuesMatchText = (personaValue, industryValue) => {
  const calculatedValue = personaValue - industryValue;
  if (calculatedValue > 0.02) {
    return 'This brand persona has social values match above the industry average.';
  } else if (0.02 >= calculatedValue && calculatedValue >= -0.02) {
    return 'This brand persona has social values match close to the industry average.';
  } else {
    return 'This brand persona has social values match below the industry average.';
  }
};

export const getProductBenefitsMatchText = (personaValue, industryValue) => {
  const calculatedValue = personaValue - industryValue;
  if (calculatedValue > 0.02) {
    return 'This brand persona has product benefits match above the industry average.';
  } else if (0.02 >= calculatedValue && calculatedValue >= -0.02) {
    return 'This brand persona has product benefits match close to the industry average.';
  } else {
    return 'This brand persona has product benefits match below the industry average.';
  }
};
